/* eslint-disable max-len */
import * as yup from 'yup';
import Moment from 'moment';

const maxNumberCharactersForModel = 50;
const hebrewEnglishNumberRegex = /^[A-Za-z\u05D0-\u05EA0-9 ]+$/;

const ValidationSchema = {
  travelers: yup.array().of(
    yup.object().shape({

      dateWinterSportRange: yup.object().nullable().shape({
        startDateWinterSport: yup
          .date()
          .typeError('validation.invalidDate').nullable()
          .when('needDateWinterSport', {
            is: true,
            then: schema => schema
              .test('is-valid-date', 'validation.invalidDate', (value) => value && Moment(value).isValid())
              .required('validation.required'),
            otherwise: schema => schema.notRequired(),
          }),
        endDateWinterSport: yup
          .date()
          .typeError('validation.invalidDate').nullable()
          .when('needDateWinterSport', {
            is: true,
            then: schema => schema
              .test('is-valid-date', 'validation.invalidDate', (value) => value && Moment(value).isValid())
              .required('validation.required'),
            otherwise: schema => schema.notRequired(),
          }),
      }),

      dateExtremeSportRange: yup.object().nullable().shape({
        startDateExtremeSport: yup
          .date()
          .typeError('validation.invalidDate').nullable()
          .when('needDateExtremeSport', {
            is: true,
            then: schema => schema
              .test('is-valid-date', 'validation.invalidDate', (value) => value && Moment(value).isValid())
              .required('validation.required'),
            otherwise: schema => schema.notRequired(),
          }),
        endDateExtremeSport: yup
          .date()
          .typeError('validation.invalidDate').nullable()
          .when('needDateExtremeSport', {
            is: true,
            then: schema => schema
              .test('is-valid-date', 'validation.invalidDate', (value) => value && Moment(value).isValid())
              .required('validation.required'),
            otherwise: schema => schema.notRequired(),
          }),
      }),
      needDateWinterSport: yup.boolean().nullable(),
      needDateExtremeSport: yup.boolean().nullable(),
      needPcCoverage: yup.boolean().nullable(),
      pc: yup.object().nullable().when('needPcCoverage', {
        is: true,
        then: () => yup.object().shape({
          manufacturer: yup
            .string()
            .transform(value =>
              typeof value === 'string' ? value.trim() : value
            )
            .matches(hebrewEnglishNumberRegex, 'validation.invalidCharacters')
            .max(maxNumberCharactersForModel, 'validation.fieldLengthExceedsLimit')
            .required('validation.required'),
          model: yup
            .string()
            .transform(value =>
              typeof value === 'string' ? value.trim() : value
            )
            .matches(hebrewEnglishNumberRegex, 'validation.invalidCharacters')
            .max(maxNumberCharactersForModel, 'validation.fieldLengthExceedsLimit')
            .required('validation.required'),
          year: yup
            .number()
            .typeError('validation.invalidYear')
            .positive('validation.invalidYear')
            .integer('validation.invalidYear')
            .min(1989, 'validation.invalidYear')
            .required('validation.required'),
        }),
        otherwise: () => yup.object().nullable(),
      }),

      needMobileCoverage: yup.boolean().nullable(),
      mobile: yup.object().nullable().when('needMobileCoverage', {
        is: true,
        then: () => yup.object().shape({
          manufacturer: yup
            .string()
            .transform(value =>
              typeof value === 'string' ? value.trim() : value
            )
            .matches(hebrewEnglishNumberRegex, 'validation.invalidCharacters')
            .max(maxNumberCharactersForModel, 'validation.fieldLengthExceedsLimit')
            .required('validation.required'),
          model: yup
            .string()
            .transform(value =>
              typeof value === 'string' ? value.trim() : value
            )
            .matches(hebrewEnglishNumberRegex, 'validation.invalidCharacters')
            .max(maxNumberCharactersForModel, 'validation.fieldLengthExceedsLimit')
            .required('validation.required'),
        }),
        otherwise: () => yup.object().nullable(),
      }),
    }),
  ),
  pcCoverError: yup.array().test('pcCoverError', 'שדה חובה', function () {
    const needneedPcCoverageTravelers = this.parent.travelers.filter(t => t.needPcCoverage);
    return this.parent.travelers.length === 1 || !this.parent.isPccover || (this.parent.travelers.length > 1 && this.parent.isPccover &&
        needneedPcCoverageTravelers.length >= 1);
  }),
  mobileCoverError: yup.array().test('mobileCoverError', 'שדה חובה', function () {
    const needneedMobileCoverageTravelers = this.parent.travelers.filter(t => t.needMobileCoverage);
    return this.parent.travelers.length === 1 || !this.parent.isMobilecover || (this.parent.travelers.length > 1 && this.parent.isMobilecover &&
          needneedMobileCoverageTravelers.length >= 1);
  }),
  dateWinterSportError: yup.object().test('dateWinterSportError', 'שדה חובה', function () {
    const needDateWinterSportTravelers = this.parent.travelers?.filter(t => t.needDateWinterSport);
    return this.parent.travelers.length === 1 || !this.parent.isWsports || (this.parent.travelers.length > 1 && this.parent.isWsports &&
      needDateWinterSportTravelers.length >= 1);
  }),
  dateExtremeSportRangeError: yup.object().test('dateExtremeSportRangeError', 'שדה חובה', function () {
    const needDateExtremeSportTravelers = this.parent.travelers?.filter(t => t.needDateExtremeSport);
    return this.parent.travelers.length === 1 || !this.parent.isEsports || (this.parent.travelers.length > 1 && this.parent.isEsports &&
      needDateExtremeSportTravelers.length >= 1);
  }),
  isOwnerHospital2: yup.string().when('isTravelsc', {
    is: true,
    then: yup.string().required('שדה חובה'),
  }),
  isCancellationOfSelfParticipationOnRentedCarError: yup.boolean().test('isCancellationOfSelfParticipationOnRentedCarError', 'שדה חובה', function () {
    const needCancellationOfSelfParticipationOnRentedCarTravelers = this.parent.travelers.filter(t => t.cancellationOfSelfParticipationOnRentedCar);
    return !this.parent.isCancellationOfSelfParticipationOnRentedCar || (this.parent.isCancellationOfSelfParticipationOnRentedCar && needCancellationOfSelfParticipationOnRentedCarTravelers.length >= 1);
  }),
};

export default ValidationSchema;